import { urlApiReview } from '~/utils/constants/apis';
import axiosClient, { CustomAxiosRequestConfig } from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IFormReply, IFormReview, IReview } from '~/utils/interface/review';
import { IQueryParamBase } from '~/utils/interface/common';

const reviewApi = {
  getReview: (params: IQueryParamBase) => {
    const url = urlApiReview.getReview;
    return axiosClient.get<IBaseResponse<IListDataResponse<IReview[]>>>(url, { params });
  },

  createReview: (body: IFormReview) => {
    const url = urlApiReview.createReview;
    return axiosClient.post<IBaseResponse>(url, body, { skipToast: true } as CustomAxiosRequestConfig);
  },

  createReply: (body: IFormReply) => {
    const url = urlApiReview.createReply;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default reviewApi;
